import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { TopBar, Notice, Spinner } from '../components/ui';

type Inv = { invoice: { id: string; shop: string; period_ar: string; amount_halalas: number; description: string; status: string; provider: string; url: string | null; paid_at: string | null }; mock: boolean };
const riyal = (h: number) => ((h / 100) % 1 === 0 ? String(h / 100) : (h / 100).toFixed(2));

/** Tempo's fee invoice as the shop owner sees it from the WhatsApp link. The only money Tempo collects. */
export default function Invoice() {
  const { id = '' } = useParams();
  const [sp] = useSearchParams();
  const [d, setD] = useState<Inv | null>(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const load = () => api.get<Inv>(`/api/public/invoices/${id}`).then(setD).catch(() => setErr('الفاتورة غير موجودة.'));
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (err) return <main className="container py-10"><TopBar /><Notice kind="danger">{err}</Notice></main>;
  if (!d) return <main className="container py-10"><TopBar /><Spinner label="نفتح الفاتورة" /></main>;
  const inv = d.invoice;
  return (
    <main className="min-h-dvh pb-16">
      <TopBar />
      <div className="container max-w-lg grid gap-4">
        {sp.get('paid') && inv.status !== 'paid' && <Notice kind="info">إن كنت دفعت للتو فستتحدث الحالة خلال لحظات.</Notice>}
        <section className="card p-6 grid gap-3">
          <div className="eyebrow">فاتورة اشتراك في تيمبو</div>
          <h1 style={{ fontSize: '1.6rem' }}>{inv.shop}</h1>
          <div className="muted">{inv.description}</div>
          <div className="display num" style={{ fontSize: '2.6rem' }}>{riyal(inv.amount_halalas)} <span className="text-base font-[inherit]">ريالًا</span></div>
          <div className="text-sm muted">عن {inv.period_ar} · السعر نهائي</div>
          {inv.status === 'paid' ? (
            <Notice kind="ok">مدفوعة{inv.paid_at ? ` · ${inv.paid_at.slice(0, 10)}` : ''}. شكرًا لك.</Notice>
          ) : inv.status !== 'initiated' ? (
            <Notice kind="warn">هذه الفاتورة {inv.status === 'canceled' ? 'ملغاة' : 'منتهية'}. تواصل معنا لإصدار فاتورة جديدة.</Notice>
          ) : inv.url ? (
            <a className="btn btn-accent btn-lg" href={inv.url}>ادفع الآن بمدى أو البطاقة أو Apple Pay</a>
          ) : d.mock ? (
            <div className="grid gap-2">
              <Notice kind="warn">بوابة الدفع قيد الإعداد. حوّل المبلغ وأرسل لنا الإيصال على واتساب، أو جرّب المحاكاة أدناه في وضع التجربة.</Notice>
              <button className="btn btn-ghost" disabled={busy} onClick={async () => { setBusy(true); await api.post(`/api/public/invoices/${id}/mock-pay`); await load(); setBusy(false); }}>محاكاة الدفع (تجربة)</button>
            </div>
          ) : (
            <Notice kind="info">حوّل المبلغ وأرسل لنا الإيصال على واتساب لتُعلَّم الفاتورة مدفوعة.</Notice>
          )}
        </section>
        <p className="muted text-xs">هذه الفاتورة بين محلك وتيمبو عن خدمة النظام، ولا علاقة لها بمدفوعات زبائنك التي تبقى عندك في المحل.</p>
      </div>
    </main>
  );
}
